import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function TenthStreet(props) {
  return (
    <SvgIcon {...props}>
      <g>
        <path
          d="M111.099 23C76.4708 23 41.8266 23 7.19798 23C7.19798 22.6486 7.22928 22.3132 7.19798 21.9618C6.94762
          19.8694 6.14958 18.0007 4.50656 16.7069C3.22345 15.6847 1.58043 15.6208 0 15.4931C0 12.7299 0 9.95069
          0 7.1875C0.92322 7.04375 1.84644 6.91597 2.75401 6.72431C5.86792 6.08542 7.68307 2.61944 7.51094
          0C41.9361 0 76.3612 0 110.786 0C110.896 0.702778 110.912 1.42153 111.115 2.09236C111.757 4.18472
          112.93 5.82986 115.105 6.51667C115.825 6.74028 116.545 6.97986 117.28 7.12361C117.828 7.23542 118
          7.49097 118 8.03403C117.969 10.1104 117.984 12.1868 117.984 14.2632C117.984 15.541 117.984 15.525
          116.717 15.6528C114.917 15.8285 113.556 16.659 112.555 18.2243C111.616 19.6778 111.068 21.2431
          111.099 23ZM116.905 14.2153C116.905 12.6021 116.873 10.7972 116.92 8.99236C116.936 8.3375 116.686
          8.11389 116.107 8.01806C112.789 7.475 110.786 5.43056 109.91 2.20417C109.754 1.64514 109.535
          1.56528 109.065 1.56528C102.337 1.59722 95.608 1.62917 88.8795 1.62917C67.3637 1.62917 45.848
          1.62917 24.3323 1.61319C19.2781 1.61319 14.2238 1.51736 9.15396 1.45347C8.66888 1.45347 8.5437
          1.69306 8.43416 2.09236C7.51094 5.35069 5.55497 7.50694 2.17504 8.09792C1.70561 8.17778 1.51784
          8.38542 1.51784 8.88056C1.53348 10.5896 1.51784 12.2826 1.53348 13.9917C1.53348 14.1674 1.59607
          14.3431 1.62737 14.5667C5.82098 14.8542 7.49529 17.7292 8.37157 21.4028C8.63758 21.4188 8.8723
          21.4347 9.10702 21.4347C42.1239 21.4347 75.1407 21.4188 108.142 21.4188C109.894 21.4188 109.832
          21.4028 110.505 19.7097C111.115 18.1924 111.694 16.5632 113.18 15.7167C114.291 15.0938 115.528
          14.7583 116.905 14.2153Z"
          fill="currentColor"
        />
        <path
          d="M32.9073 12.9855C32.9073 11.2445 32.9386 9.75908 32.8916 8.28963C32.876 8.00213 32.6413
          7.63477 32.4066 7.49102C31.9528 7.20352 31.8745 6.78824 32.031 6.40491C32.1092 6.21324 32.5474
          6.08547 32.829 6.06949C33.7366 6.02158 34.6285 6.05352 35.6457 6.05352C35.5518 6.42088 35.5518
          6.59658 35.4579 6.69241C34.7694 7.50699 34.7224 8.46533 34.7381 9.4556C34.7537 11.532 34.7381
          13.6084 34.7381 15.6848C34.7381 15.9403 34.7381 16.2119 34.7381 16.5632C34.1122 16.5313 33.5332
          16.5473 32.9855 16.4514C32.7978 16.4195 32.6256 16.116 32.5004 15.9084C31.3895 14.0556 30.2785
          12.1869 29.1675 10.3341C29.0266 10.0945 28.8389 9.88685 28.6354 9.59935C28.6354 10.6855 28.6354
          11.6598 28.6354 12.6181C28.6354 13.2091 28.6511 13.7841 28.6354 14.375C28.6198 14.8542 28.6511
          15.1417 29.2457 15.2535C29.4804 15.3014 29.5743 15.9723 29.8247 16.5632C28.432 16.5632 27.3054
          16.5632 26.1631 16.5473C26.0536 16.5473 25.8501 16.3556 25.8658 16.2757C25.9284 15.9563 25.991
          15.4452 26.1787 15.3813C26.8672 15.1417 26.8046 14.6146 26.8046 14.0875C26.8046 12.1709 26.789
          10.2542 26.7577 8.33755C26.7577 8.06602 26.6795 7.65074 26.5073 7.57088C25.7875 7.23547 25.9597
          6.64449 25.9597 6.05352C26.8672 6.05352 27.7279 6.03755 28.6041 6.06949C28.7137 6.06949 28.8389
          6.30908 28.9327 6.45283C30.0124 8.3056 31.0608 10.1584 32.1405 12.0112C32.3127 12.3146 32.563
          12.5702 32.9073 12.9855Z"
          fill="currentColor"
        />
        <path
          d="M44.784 6.10144C46.0358 6.10144 47.2407 6.10144 48.7116 6.10144C47.8979 7.44311 47.3033 8.73686
          47.6632 10.2862C48.9932 10.2862 50.3546 10.2862 51.7942 10.2862C51.7316 9.43963 51.669 8.67297
          51.5908 7.92227C51.5751 7.77852 51.4969 7.57088 51.3873 7.52297C50.6988 7.23547 50.9179 6.69241
          50.9805 6.11741C52.1384 6.11741 53.2964 6.11741 54.5795 6.11741C54.4543 6.51672 54.4543 6.932
          54.2509 7.12366C53.7814 7.55491 53.7502 8.06602 53.7502 8.64102C53.7502 10.6056 53.7189 12.5702
          53.7345 14.5507C53.7345 14.8862 53.6719 15.2535 54.2039 15.4132C54.3917 15.4612 54.4387 16.116
          54.5638 16.5632C53.2494 16.5632 52.1228 16.5632 50.9335 16.5632C50.8084 16.0042 50.6206 15.4612
          51.4186 15.1896C51.5438 15.1417 51.6533 14.8542 51.6533 14.6625C51.6846 13.8639 51.669 13.0813
          51.669 12.2028C50.3546 12.2028 49.0245 12.2028 47.5693 12.2028C47.6006 13.0813 47.6319 13.9757
          47.6944 14.8542C47.7101 15.0139 47.8353 15.2535 47.9605 15.2855C48.6177 15.4771 48.4612 15.9882
          48.4455 16.5313C47.2094 16.5313 46.0045 16.5313 44.7527 16.5313C44.7527 16.1639 44.7527 15.8125
          44.7527 15.4132C45.05 15.3334 45.316 15.2535 45.6133 15.1737C45.6133 12.8577 45.6289 10.5577
          45.5976 8.24172C45.5976 7.95422 45.4099 7.53894 45.2065 7.42713C44.6275 7.10769 44.737 6.6445
          44.784 6.10144Z"
          fill="currentColor"
        />
        <path
          d="M74.7495 6.19716C76.017 6.19716 77.2062 6.18119 78.3954 6.19716C79.1778 6.21313 79.9759 6.22911
          80.7113 6.4048C81.1338 6.50063 81.6032 6.868 81.838 7.25133C82.7299 8.72077 82.4639 10.2701 81.2433
          11.484C81.1025 11.6117 81.0556 12.027 81.1494 12.2027C81.8067 13.2888 82.0257 14.6624 83.1367
          15.461C83.2932 15.5729 83.3088 16.036 83.215 16.2756C83.168 16.4354 82.8238 16.5631 82.6047
          16.5631C81.8849 16.5951 81.1495 16.611 80.414 16.5631C80.148 16.5472 79.7255 16.3715 79.6629
          16.1798C79.5377 15.8124 79.5064 15.3173 80.1167 15.2055C80.2106 15.1895 80.2888 15.0937 80.3671
          15.0458C79.835 12.9534 79.3656 12.5062 77.5974 12.5701C77.5974 13.3527 77.5974 14.1513 77.5974
          14.934C77.5974 15.0458 77.6756 15.2374 77.7539 15.2534C78.505 15.461 78.1607 16.036 78.2233
          16.5312C77.0184 16.5312 75.8605 16.5312 74.6869 16.5312C74.593 15.9242 74.4522 15.3972 75.2189
          15.1576C75.3598 15.1097 75.5006 14.7263 75.5006 14.4867C75.5162 12.5701 75.5319 10.6534 75.4693
          8.75272C75.4537 8.20966 75.1251 7.68258 74.9686 7.13952C74.8903 6.85202 74.8277 6.51661 74.7495
          6.19716ZM77.6131 10.9569C80.1793 10.8291 80.68 10.4617 80.4922 9.00827C80.3514 7.90619 79.303
          7.44299 77.6131 7.79438C77.6131 8.83258 77.6131 9.87077 77.6131 10.9569Z"
          fill="currentColor"
        />
        <path
          d="M17.7759 6.03748C20.0292 6.03748 22.2355 6.03748 24.5201 6.03748C24.5201 6.94789 24.5201 7.87428
          24.5201 8.88053C23.9255 8.80067 23.2526 8.97636 23.0336 8.11386C23.0023 7.98609 22.7832 7.82636
          22.658 7.82636C21.9852 7.79442 21.3123 7.81039 20.5769 7.81039C20.5769 8.609 20.5769 9.37567
          20.5769 10.2541C21.2654 10.3021 21.9695 10.35 22.6893 10.3819C24.0663 10.4298 24.0663 10.4298
          23.8629 11.9791C22.7988 12.043 21.7192 12.1069 20.6082 12.1708C20.6082 13.0493 20.6082 13.9118
          20.6082 14.8701C21.4062 14.8701 22.126 14.9021 22.8458 14.8382C23.0179 14.8222 23.2683 14.5028
          23.3152 14.2791C23.4091 13.8 23.5499 13.5125 24.1133 13.5444C24.6922 13.5764 24.7079 13.9757
          24.7235 14.375C24.7548 15.0778 24.7235 15.7965 24.7235 16.4993C22.3451 16.4993 20.0448 16.4993
          17.729 16.4993C17.6351 15.8604 17.5725 15.3653 18.2923 15.1736C18.4331 15.1416 18.5896 14.8062
          18.5896 14.5986C18.5739 12.4264 18.527 10.2382 18.4644 8.06595C18.4644 7.85831 18.3549 7.53886
          18.1984 7.44303C17.6664 7.15553 17.6664 6.69234 17.7759 6.03748Z"
          fill="currentColor"
        />
        <path
          d="M95.1855 7.81053C95.1855 8.60914 95.1855 9.37581 95.1855 10.2383C95.8427 10.2862 96.5 10.3341
          97.1572 10.3661C98.5185 10.43 98.5185 10.43 98.3464 11.9633C97.3136 12.0432 96.2652 12.1071 95.2168
          12.1869C95.2168 13.1133 95.2168 14.0237 95.2168 15.014C95.7801 15.014 96.2809 14.998 96.766
          15.014C97.4388 15.046 97.9552 14.9022 98.0178 14.0716C98.0491 13.6244 98.3777 13.4647 98.7376
          13.6244C98.988 13.7362 99.3478 13.9918 99.3791 14.2154C99.4574 14.9661 99.4104 15.7328 99.4104
          16.5633C97.0789 16.5633 94.7474 16.5633 92.3533 16.5633C92.322 16.0203 92.0873 15.4293 92.901
          15.1897C93.0105 15.1578 93.12 14.9501 93.1357 14.8383C93.1513 12.5862 93.1513 10.3341 93.1357
          8.06609C93.1357 7.85845 92.9948 7.60289 92.8384 7.45914C92.3063 6.90012 92.2907 6.91609 92.4159
          6.05359C94.6379 6.05359 96.8599 6.05359 99.1601 6.05359C99.1601 6.94803 99.1601 7.84248 99.1601
          8.78484C98.5811 8.84873 98.0178 8.99248 97.7831 8.19387C97.7361 8.03414 97.4545 7.85845 97.2823
          7.84248C96.5782 7.77859 95.9053 7.81053 95.1855 7.81053Z"
          fill="currentColor"
        />
        <path
          d="M84.013 6.1333C86.4384 6.1333 88.676 6.1333 90.9763 6.1333C90.9763 7.05969 90.9763 7.92219
          90.9763 8.86455C90.3816 8.70483 89.5367 9.19997 89.3958 8.04997C89.3802 7.93816 89.1298 7.81038
          88.989 7.79441C88.3161 7.76247 87.6433 7.77844 86.9078 7.77844C86.9078 8.59302 86.9078 9.40761
          86.9078 10.3819C87.6589 10.3819 88.3787 10.3659 89.0985 10.3819C90.4286 10.4298 90.4599 10.4777
          90.2408 11.9791C89.1611 12.043 88.0501 12.1069 86.9235 12.1868C86.9235 13.1132 86.9235 14.0236
          86.9235 14.9979C87.6902 14.9979 88.3944 14.9979 89.0829 14.9979C89.5523 14.9979 89.7088 14.6784
          89.7401 14.2791C89.787 13.6562 90.1782 13.6083 90.6633 13.6243C91.211 13.6402 91.1953 14.0396
          91.1953 14.4069C91.211 15.0937 91.1953 15.7805 91.1953 16.5152C91.0545 16.5472 90.898 16.6111
          90.7572 16.6111C88.7699 16.6111 86.7983 16.6271 84.811 16.5791C84.5137 16.5791 84.0443 16.3715
          83.9817 16.1479C83.8409 15.6847 84.1382 15.3972 84.6232 15.2534C84.8267 15.1896 85.077 14.8701
          85.077 14.6784C85.0301 12.5062 84.9519 10.318 84.8423 8.1458C84.8267 7.84233 84.4668 7.58677
          84.3416 7.2833C84.2008 6.91594 84.1382 6.54858 84.013 6.1333Z"
          fill="currentColor"
        />
        <path
          d="M62.2156 6.00549C62.8102 6.06938 63.4049 6.18119 63.9995 6.19716C64.6254 6.2291 64.7975 6.56452
          64.7819 7.12355C64.7662 7.52285 64.8445 7.92216 64.7662 8.32147C64.7193 8.59299 64.5315 9.04022
          64.375 9.05619C63.9369 9.12008 63.4362 9.12008 63.3266 8.43327C63.264 8.06591 63.4362 7.45897
          62.6851 7.50688C61.7462 7.5548 60.6665 8.06591 60.6352 8.65688C60.6195 8.97633 60.7447 9.40758
          60.9794 9.63119C61.3081 9.95063 61.7462 10.1583 62.1687 10.3499C62.5912 10.5576 63.0606 10.6694
          63.4675 10.877C64.6097 11.436 65.4078 12.3465 65.3921 13.6402C65.3765 14.902 64.6723 15.8284 63.53
          16.4513C62.0122 17.2819 60.5413 16.7708 59.0548 16.4194C58.9296 16.3874 58.7731 16.1479 58.7731
          16.0041C58.7418 15.2854 58.7105 14.5666 58.7731 13.8638C58.7888 13.7041 59.133 13.4326 59.2895
          13.4645C59.5711 13.5124 59.978 13.6722 60.0719 13.9117C60.6352 15.2534 61.1203 15.477 62.4973
          15.0617C63.1075 14.8701 63.4049 14.4069 63.3579 13.9117C63.3266 13.4965 62.998 12.9694 62.6381
          12.7458C61.934 12.3145 61.1203 12.0749 60.3848 11.7076C59.0235 11.0527 58.4132 9.93466 58.6949
          8.67285C59.1174 6.82008 59.9154 6.10133 61.6054 6.06938C61.8088 6.06938 62.0279 6.06938 62.2313
          6.06938C62.2 6.03744 62.2156 6.02147 62.2156 6.00549Z"
          fill="currentColor"
        />
        <path
          d="M73.9202 6.08545C73.9202 7.05975 73.9202 7.9542 73.9202 8.89656C73.4351 8.89656 73.0283 8.89656
          72.6214 8.89656C72.1363 7.63475 72.1363 7.63475 70.9627 7.7785C70.9627 8.33753 70.9627 8.91253
          70.9627 9.48753C70.9627 11.0528 70.9784 12.6341 70.9471 14.1993C70.9471 14.8702 70.994 15.4452
          71.8703 15.3174C72.2615 16.4834 72.1989 16.5952 71.0723 16.5952C70.1647 16.5952 69.2415 16.5632
          68.3339 16.5632C67.9271 16.5632 67.708 16.4195 67.7237 15.9563C67.7393 15.525 67.8645 15.3014
          68.3026 15.3174C68.7408 15.3334 69.0381 15.2056 69.0381 14.6466C69.0224 12.3945 69.0381 10.1264
          69.0381 7.82642C68.3183 7.74656 67.708 7.68267 67.442 8.641C67.3794 8.88059 66.6283 8.9285 66.0963
          9.08823C66.0963 7.9542 66.0963 7.04378 66.0963 6.10142C68.7095 6.08545 71.2757 6.08545 73.9202
          6.08545Z"
          fill="currentColor"
        />
        <path
          d="M39.229 7.82634C37.9146 7.71453 37.9146 7.7305 37.6173 8.86453C36.2872 9.12009 36.1464 9.00828
          36.1464 7.68259C36.1464 7.18745 36.1464 6.69231 36.1464 6.11731C36.7567 6.11731 37.2574 6.11731
          37.7738 6.11731C39.6045 6.13328 41.4197 6.16523 43.2505 6.14925C43.7982 6.14925 44.0798 6.27703
          44.0485 6.88398C44.0172 7.53884 44.0485 8.1937 44.0485 8.89648C43.5478 8.89648 43.1253 8.89648
          42.6246 8.89648C42.5776 8.67287 42.515 8.44925 42.515 8.22564C42.4837 7.6187 42.0456 7.71453
          41.6701 7.68259C41.2006 7.63467 41.1693 7.93814 41.1693 8.28953C41.185 10.3659 41.2006 12.4423
          41.2163 14.5187C41.2163 14.9499 41.3258 15.2055 41.8265 15.3652C42.0769 15.4451 42.1864 16.0361
          42.4211 16.5312C40.8094 16.5312 39.4168 16.5312 37.9615 16.5312C37.9615 16.1319 37.9615 15.7805
          37.9615 15.4451C39.2759 15.1256 39.2603 15.1256 39.2603 13.6722C39.229 11.7395 39.229 9.80689
          39.229 7.82634Z"
          fill="currentColor"
        />
        <path
          d="M105.169 15.1417C105.576 15.2056 105.936 15.2695 106.342 15.3494C106.342 15.7167 106.342 16.0681
          106.342 16.5154C104.934 16.5154 103.541 16.5154 102.055 16.5154C102.039 16.164 102.024 15.8126
          102.008 15.4931C102.086 15.4292 102.118 15.3654 102.164 15.3654C103.26 15.1577 103.244 15.1577
          103.244 14.0397C103.244 11.9792 103.244 9.90286 103.244 7.87438C102.008 7.57091 102.008 7.57091
          101.648 8.86466C100.381 9.13619 100.318 9.0723 100.302 7.76258C100.302 7.18758 100.302 6.61258
          100.302 6.02161C102.916 6.02161 105.435 6.02161 108.111 6.02161C108.064 6.90008 108.032 7.74661
          107.938 8.56119C107.923 8.70494 107.594 8.91258 107.438 8.89661C107.172 8.86466 106.734 8.72091
          106.702 8.54522C106.53 7.6348 105.92 7.61883 105.169 7.69869C105.169 10.1584 105.169 12.6181
          105.169 15.1417Z"
          fill="currentColor"
        />
        <path
          d="M16.8996 6.02161C16.8996 6.62855 16.8996 7.09175 16.8996 7.57091C16.8996 8.9605 16.884 8.97647
          15.4131 8.86466C15.3661 8.12994 15.3035 7.31536 14.1456 7.74661C14.1456 10.1584 14.1456 12.6181
          14.1456 15.0779C15.2409 15.3174 15.2409 15.3174 15.1314 16.5154C13.8014 16.5154 12.4713 16.5154
          11.1099 16.5154C11.1099 16.132 11.1099 15.7966 11.1099 15.4452C12.1896 15.0459 12.1896 15.0459
          12.2053 13.7522C12.2053 11.7716 12.2053 9.77508 12.2053 7.77855C11.4229 7.66675 10.8439 7.55494
          10.6718 8.43341C10.5466 9.02438 10.0615 8.91258 9.65469 8.89661C9.2009 8.88063 9.13831 8.57716
          9.15396 8.17786C9.18525 7.47508 9.16961 6.75633 9.16961 6.02161C11.7358 6.02161 14.2708 6.02161
          16.8996 6.02161Z"
          fill="currentColor"
        />
        <path
          d="M5.6645 10.0625C6.39994 10.0625 6.7129 10.4458 6.7129 11.3083C6.69725 12.059 6.30606
          12.4424 5.53932 12.4583C4.86646 12.4743 4.38138 11.9632 4.38138 11.2604C4.38138 10.4618
          4.80387 10.0625 5.6645 10.0625Z"
          fill="currentColor"
        />
        <path
          d="M112.852 12.4583C112.038 12.4583 111.647 12.043 111.663 11.1646C111.678 10.4458 112.116 10.0465
          112.868 10.0465C113.587 10.0465 113.869 10.3819 113.9 11.2285C113.932 12.0271 113.556 12.4583
          112.852 12.4583Z"
          fill="currentColor"
        />
        <path
          d="M77.613 10.957C77.613 9.8709 77.613 8.81673 77.613 7.77854C79.2874 7.44312 80.3514 7.89034
          80.4922 8.99243C80.68 10.4778 80.1793 10.8292 77.613 10.957Z"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
}
